<template>
  <div>
     <component v-bind:is="currentTab" ></component>
  </div>
</template>

<script>
import Vue from 'vue'
Vue.component('color-1', {template: '<link rel="stylesheet" type="text/css" href="/static/color/color-1.css" />'})
export default {
  name: 'color',
  data () {
    return {
      currentTab: 'color-1'// set color of website
    }
  },
  mounted () {
    this.currentTab = 'color-1'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/color.vue